import { render, staticRenderFns } from "./UserActionDeactivateDialog.vue?vue&type=template&id=4721ae98&"
import script from "./UserActionDeactivateDialog.vue?vue&type=script&lang=js&"
export * from "./UserActionDeactivateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports